import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import axios from 'axios';

import { Row, Col, Button, Card, CardHeader, CardFooter, CardBody, Form, FormGroup, Label, Input, Table, Alert, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import * as vars from '../../constants/variables';

import { show, hide } from "../../actions/ActivityIndicatorActions";
import { getRoles, getUsers } from "../../actions/UsersActions";

import { console_log, jsUcfirst, formatDate } from "../../utils/helper";
import { FormattedMessage } from 'react-intl';

class Users extends Component {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            accessType: '',
            password: '',
            showModal: false,
            edit_userId: '',
            edit_username: '',
            edit_accessType: '',
            edit_password: '',
            edit_isActive: false,
            edit_isValid: false,
            edit_errorMessage: '',
            isValid: false,
            errorMessage: ''
        };

        this.isValid = this.isValid.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onChange = this.onChange.bind(this);
        this.modalToggle = this.modalToggle.bind(this);
        this.editUserSubmit = this.editUserSubmit.bind(this);
        this.isValidEditForm = this.isValidEditForm.bind(this);
        this.editUser = this.editUser.bind(this);
        this.deleteUser = this.deleteUser.bind(this);
        this.onEditChange = this.onEditChange.bind(this);
    }

    componentWillMount() {
        this.getRoles();
        this.getUser();
    }

    componentDidUpdate() {
        if (!this.props.user.isAuthenticated) {
            this.props.history.push('/login');
        }
    }

    getRoles() {
        axios.get(vars.BASE_URL+'/getRoles')
            .then((response) => {
                if (response.data.success) {
                    this.props.getRoles(response.data);
                }
            })
            .catch((error) => {
                console_log(error);
                this.setState({ isValid: false, errorMessage: 'Unable to fetch the data.'});
            });
    }

    onSubmit(e) {
        e.preventDefault();

        if(this.isValid()){
            this.setState({ isValid: true, errorMessage: ''});
            this.addUser({
                username: this.state.username,
                password: this.state.password,
                roleName: this.state.accessType
            });
        }
    }

    isValid() {
        if (this.state.username == '') {
            this.setState({
                isValid: false,
                errorMessage: "Username field is required."
            });
            return false;
        }
        if (this.state.password == '') {
            this.setState({
                isValid: false,
                errorMessage: "Password field is required."
            });
            return false;
        }
        if (this.state.accessType == '') {
            this.setState({
                isValid: false,
                errorMessage: "Please select the role of the user"
            });
            return false;
        }

        return true;
    }

    onChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    addUser(data) {
        this.props.show();
        axios.post(vars.BASE_URL+'/signup', data)
            .then((response) => {
                this.props.hide();
                if (response.data.success) {
                    this.getUser();
                }
                this.setState({
                    username: '',
                    accessType: '',
                    password: '',
                    isValid: false,
                    errorMessage: ''
                })
            })
            .catch((error) => {
                this.props.hide();
                console_log(error);
                this.setState({ isValid: false, errorMessage: 'Sorry, cannot add user right now, please try again later.'});
            });
    }

    getUser() {
        this.props.show();
        axios.get(vars.BASE_URL+'/getUsers')
            .then((response) => {
                this.props.hide();
                if (response.data.success) {
                    this.props.getUsers(response.data);
                }
            })
            .catch((error) => {
                this.props.hide();
                console_log(error);
                this.setState({ isValid: false, errorMessage: 'Unable to fetch data.'});
            });
    }

    modalToggle(user) {
        this.setState({
            showModal: !this.state.showModal,
            edit_userId: user.userId,
            edit_username: user.username,
            edit_accessType: user.roleName,
            edit_isActive: user.isActive,
            edit_password: '',
            edit_isValid: false,
            edit_errorMessage: ''
        })
    }

    isValidEditForm() {
        if (this.state.edit_username == '') {
            this.setState({
                edit_isValid: false,
                edit_errorMessage: "Username field is required."
            });
            return false;
        }
        if (this.state.edit_password == '') {
            this.setState({
                edit_isValid: false,
                edit_errorMessage: "Password field is required."
            });
            return false;
        }
        if (this.state.edit_accessType == '') {
            this.setState({
                edit_isValid: false,
                edit_errorMessage: "Please select the role of the user"
            });
            return false;
        }

        return true;
    }

    editUserSubmit(e) {
        e.preventDefault();

        if(this.isValidEditForm()){
            this.setState({ edit_isValid: true, edit_errorMessage: ''});
            this.editUser({
                userId: this.state.edit_userId,
                username: this.state.edit_username,
                password: this.state.edit_password,
                roleName: this.state.edit_accessType,
                isActive: (this.state.edit_isActive == "true")? true : false
            });
        }
    }

    onEditChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    editUser(user) {
        this.props.show();
        axios.put(vars.BASE_URL+'/editUser',  user, { headers: {
                'Authorization': this.props.user.currentUser.token
            }})
            .then((response) => {
                this.props.hide();
                if (response.data.success) {
                    this.modalToggle({userId: '', username: '', isActive: false, roleName: ''});
                    this.getUser();
                    this.setState({
                        edit_userId: '',
                        edit_username: '',
                        edit_accessType: '',
                        edit_password: '',
                        edit_isValid: false,
                        edit_errorMessage: ''
                    })
                }
            })
            .catch((error) => {
                this.props.hide();
                console_log(error);
                this.setState({ isValid: false, errorMessage: 'Sorry, cannot edit user right now, please try again later.'});
            });
    }

    deleteUser(user) {
        this.props.show();
        axios.delete(vars.BASE_URL+'/deleteUser',  {
            data: {
                userId: user.userId,
            },
            headers: {
                'Authorization': this.props.user.currentUser.token
            }
        })
            .then((response) => {
                this.props.hide();
                if (response.data.success) {
                    this.getUser();
                }
            })
            .catch((error) => {
                this.props.hide();
                console_log(error);
                this.setState({ isValid: false, errorMessage: 'Sorry, cannot delete user right now, please try again later.'});
            });
    }

    render() {
        return (
            <div className="users animated fadeIn">
                <Row>
                    <Col xs="12" md="12">
                        <Card>
                            <CardHeader>
                                <strong>Add User</strong>
                            </CardHeader>
                            <CardBody>
                                <Form action="" method="post" encType="multipart/form-data" className="form-horizontal">
                                    <FormGroup row>
                                        <Col md="3">
                                            <Label htmlFor="username">Username</Label>
                                        </Col>
                                        <Col xs="12" md="9">
                                            <Input type="text" id="username" name="username" placeholder="Username" value={this.state.username} onChange={this.onChange}/>
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Col md="3">
                                            <Label htmlFor="accessType">Access Type</Label>
                                        </Col>
                                        <Col xs="12" md="9" size="sm">
                                            <Input type="select" name="accessType" id="accessType" value={this.state.accessType} onChange={this.onChange}>
                                                <option key={0} value={''}>Select Role</option>
                                                {(this.props.users.roles) ?
                                                    this.props.users.roles.map((role) => {
                                                        return <option key={role.roleId} value={role.name}>{role.name}</option>
                                                    })
                                                    : ''
                                                }
                                            </Input>
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Col md="3">
                                            <Label htmlFor="password">Password</Label>
                                        </Col>
                                        <Col xs="12" md="9">
                                            <Input type="password" id="password" name="password" placeholder="Password" value={this.state.password} onChange={this.onChange}/>
                                        </Col>
                                    </FormGroup>
                                    {(!this.state.isValid && this.state.errorMessage != '') ?
                                        <Alert color="danger">{this.state.errorMessage}</Alert> : ''}
                                </Form>
                            </CardBody>
                            <CardFooter className="card-footer-align-right">
                                <Button type="submit" color="primary" onClick={this.onSubmit}><i className="fa fa-check"></i> Create</Button>
                            </CardFooter>
                        </Card>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <Card>
                            <CardBody>
                                <Table hover responsive size="lg" className="users-custom-table">
                                    <thead>
                                        <tr>
                                            <th>Username</th>
                                            <th>Access</th>
                                            <th>Date</th>
                                            <th>Status</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {(this.props.users.users.length > 0) ?
                                            this.props.users.users.map((user, key) => {
                                                return (
                                                    <tr key={key}>
                                                        <td><strong>{jsUcfirst(user.username)}</strong></td>
                                                        <td>{jsUcfirst(user.roleName)}</td>
                                                        <td>{formatDate(user.createdAt)}</td>
                                                        <td>{(user.isActive) ? 'Active' : 'Inactive'}</td>
                                                        <td>
                                                            <Button size="sm" disabled={(user.roleName == 'superadmin')? true : false} color="success" onClick={this.modalToggle.bind(this, user)}>
                                                                <i className="fa fa-edit"></i>
                                                            </Button>
                                                            <Button size="sm" disabled={(user.roleName == 'superadmin')? true : false} color="danger" onClick={this.deleteUser.bind(this, user)}>
                                                                <i className="fa fa-trash"></i>
                                                            </Button>
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                            : <tr>
                                                <td colSpan={5}>
                                                    No users added yet.
                                                </td>
                                            </tr>
                                        }
                                    </tbody>
                                </Table>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <Modal isOpen={this.state.showModal} toggle={this.modalToggle.bind(this, {userId: '', username: '', isActive: false, roleName: ''})} className='modal-lg'>
                    <ModalHeader toggle={this.modalToggle.bind(this, {userId: '', username: '', isActive: false, roleName: ''})}>Edit User</ModalHeader>
                    <ModalBody>
                        <Form action="" method="post" encType="multipart/form-data" className="form-horizontal">
                            <FormGroup row>
                                <Col md="3">
                                    <Label htmlFor="edit_username">Username</Label>
                                </Col>
                                <Col xs="12" md="9">
                                    <Input type="text" id="edit_username" name="edit_username" placeholder="Username" value={this.state.edit_username} onChange={this.onEditChange}/>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Col md="3">
                                    <Label htmlFor="edit_accessType">Access Type</Label>
                                </Col>
                                <Col xs="12" md="9" size="sm">
                                    <Input type="select" name="edit_accessType" id="edit_accessType" value={this.state.edit_accessType} onChange={this.onEditChange}>
                                        <option key={0} value={''}>Select Role</option>
                                        {(this.props.users.roles) ?
                                            this.props.users.roles.map((role) => {
                                                return <option key={role.roleId} value={role.name}>{role.name}</option>
                                            })
                                            : ''
                                        }
                                    </Input>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Col md="3">
                                    <Label htmlFor="edit_isActive">Status</Label>
                                </Col>
                                <Col xs="12" md="9" size="sm">
                                    <Input type="select" name="edit_isActive" id="edit_isActive" value={this.state.edit_isActive} onChange={this.onEditChange}>
                                        <option key={0} value={true}>Active</option>
                                        <option key={1} value={false}>Inactive</option>
                                    </Input>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Col md="3">
                                    <Label htmlFor="edit_password">Password</Label>
                                </Col>
                                <Col xs="12" md="9">
                                    <Input type="password" id="edit_password" name="edit_password" placeholder="Password" value={this.state.edit_password} onChange={this.onEditChange}/>
                                </Col>
                            </FormGroup>
                            {(!this.state.edit_isValid && this.state.edit_errorMessage != '') ?
                                <Alert color="danger">{this.state.edit_errorMessage}</Alert> : ''}
                        </Form>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="danger" onClick={this.modalToggle.bind(this, {userId: '', username: '', isActive: false, roleName: ''})}>
                            <FormattedMessage id="cancel"
                                defaultMessage=" Cancel"
                            />
                        </Button>{' '}
                        <Button color="success" onClick={this.editUserSubmit}>
                            <FormattedMessage id="save"
                                defaultMessage=" Save"
                            />
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.AuthenticationReducer,
        access: state.WelcomeReducer,
        domains: state.DomainReducer,
        country: state.CountryReducer,
        users: state.UsersReducer
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        show,
        hide,
        getRoles,
        getUsers
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Users);


// WEBPACK FOOTER //
// ./src/components/User/Users.js